module.exports = __webpack_public_path__ + "img/parts-defaultImg.078185f3.png";